module.exports = window.dnn.nodeModules.ReduxThunk;